import { Select as AntSelect } from "antd";
import type { SelectProps as AntSelectProps } from "antd";

export function Select(props: AntSelectProps) {
  return <AntSelect {...props} />;
}
